module.exports = __webpack_public_path__ + "img/12_icon_right_arrow_line@2x.0f0072e9.png";